module.exports = __webpack_public_path__ + "static/media/policy-4.cedfb44c.png";